import { render, staticRenderFns } from "./EventLeave.vue?vue&type=template&id=6084ca34&scoped=true&"
import script from "./EventLeave.vue?vue&type=script&lang=js&"
export * from "./EventLeave.vue?vue&type=script&lang=js&"
import style0 from "./EventLeave.vue?vue&type=style&index=0&id=6084ca34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6084ca34",
  null
  
)

export default component.exports